import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import { Div, P, Loading } from 'konsys-ui'
import detailType from '../util-functions'
import { CREATE_TRAILER, UPDATE_TRAILER } from '../../../constants/graphql/mutation'
import { TRUCK_TYPE, TRAILER_INFO } from '../../../constants/graphql/query'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/trailer-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState({})

  let onChangeHandler = (id, value, optional) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: value,
    })
  }

  let selectedList = {}
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      <Query
        query={TRUCK_TYPE}
      >
        {
          ({ loading: truckTypeloading, data: truckType, error: truckTypeError }) => {
            if (truckTypeloading && _.isEmpty(truckType)) return <Loading center='true' />
            if (truckTypeError) return <P>เกิดข้อผิดพลาด</P>
            selectedList = {
              ...selectedList,
              truckTypeId: truckType.TruckTypes.lists.map(v => (
                { value: v.id, text: `${v.nameTh}  ( น้ำหนัก ${v.minWeight || 0} - ${v.maxWeight || 0} kg.)` }
              )),
            }
            return isAddMode
              ? <Div>
                {detailType(props.match.params, onChangeHandler, mutationVariables, selectedList)}
                <Mutation
                  mutation={isAddMode ? CREATE_TRAILER : UPDATE_TRAILER}
                >{(doAction, resp) => (
                  <ActionBar
                    loading={resp.loading}
                    disabled={_.isUndefined(mutationVariables.trailerPlate) || _.isEmpty(mutationVariables.trailerPlate)
                      || _.isUndefined(mutationVariables.truckTypeId)}
                    isAddMode={isAddMode}
                    isViewMode={isViewMode}
                    doAction={doAction}
                    mutationVariables={{ ...mutationVariables }}
                    props={props}
                  />
                )}
                </Mutation>
              </Div>
              : <Query
                query={TRAILER_INFO}
                variables={{ id: props.match.params.id }}
                fetchPolicy='cache-and-network'
              >{({
                data, error, loading,
              }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                let trailerData = {
                  ...data.TrailerInfo,
                }
                if (!_.isNull(data.TrailerInfo.type)) {
                  trailerData = {
                    ...trailerData,
                    truckTypeId: `${data.TrailerInfo.type.nameTh} ( น้ำหนัก ${data.TrailerInfo.type.minWeight || 0} - ${data.TrailerInfo.type.maxWeight || 0} kg.)`,
                  }
                }
                onChangeHandler = (id, value) => {
                  setMutationVariables({
                    trailerPlate: data.TrailerInfo.trailerPlate,
                    chassisNumber: data.TrailerInfo.chassisNumber,
                    truckTypeId: data.TrailerInfo.truckTypeId,
                    ...mutationVariables,
                    [id]: value,
                  })
                }
                return (
                  <Div>
                    {
                      detailType(props.match.params, onChangeHandler, mutationVariables, selectedList, trailerData) // argument mode
                    }
                    {/* ================== Footer section ================== */}
                    {!isViewMode ? <Mutation
                      mutation={isAddMode ? CREATE_TRAILER : UPDATE_TRAILER}
                    >{(doAction, resp) => (
                      <ActionBar
                        loading={resp.loading}
                        disabled={_.isUndefined(mutationVariables.trailerPlate) || _.isEmpty(mutationVariables.trailerPlate)
                          }
                        isAddMode={isAddMode}
                        isViewMode={isViewMode}
                        doAction={doAction}
                        mutationVariables={{ ...mutationVariables }}
                        props={props}
                      />
                    )}
                    </Mutation>
                      : <ActionBar
                        isAddMode={isAddMode}
                        isViewMode={isViewMode}
                        props={props}
                      />
                    }
                  </Div>
                )
              }}
              </Query>
          }
        }
      </Query>
    </Div>
  )
}

export default Index
export { Index }
